import {
  USER_SEARCH_INITIAL_STATE,
  UserSearchState,
} from './list-owners.state';
import {
  UserSearchActionTypes,
  UserSearchActions,
} from './user-search.actions';

export function userSearchReducer(
  state: UserSearchState = USER_SEARCH_INITIAL_STATE,
  action: UserSearchActions,
): UserSearchState {
  switch (action.type) {
    case UserSearchActionTypes.USER_SEARCH_CLEARED: {
      return USER_SEARCH_INITIAL_STATE;
    }

    case UserSearchActionTypes.USER_SEARCH_INITIATED: {
      return {
        error: null,
        isLoading: true,
        searchResults: null,
        searchTerm: action.payload.searchTerm,
      };
    }

    case UserSearchActionTypes.USER_SEARCH_RESULTS_LOADED: {
      const { searchTerm, results } = action.payload;

      if (searchTerm !== state.searchTerm) {
        // We've moved on to a new search, so don't modify state
        return state;
      }

      return {
        error: null,
        isLoading: false,
        searchResults: results,
        searchTerm,
      };
    }

    case UserSearchActionTypes.USER_SEARCH_FAILED: {
      const { searchTerm, error } = action.payload;

      if (searchTerm !== state.searchTerm) {
        // We've moved on to a new search, so don't modify state
        return state;
      }

      return {
        error,
        isLoading: false,
        searchResults: null,
        searchTerm,
      };
    }

    default: {
      return state;
    }
  }
}
